import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useSubscribeToNewsletter} from "../../newsletter/hooks/useSubscribeToNewsletter";
import {NewsletterSubscriptionPayloadType} from "../../newsletter/types/NewsletterSubscriptionPayloadType";
import {useRecentFilters} from "../hooks/use_recent_filters";
import {useTrackAmplitudeGlobalSearch} from "../tracking/use_track_amplitude_global_search";
import {buildRecentSearchFormValues, buildSearchUrl} from "../utils/build_recent_filters_search_values";
import {getRecentFilterFilterText} from "../utils/recent_filters_display_utils";

interface IProps {
    className?: string;
}

export const RecentFiltersSearch = (props: IProps) => {
    const {className} = props;

    const {recentFilters} = useRecentFilters();
    const {saveNewsletterSearchData} = useSubscribeToNewsletter();
    const {trackAmplitudeSearch, buildAmplitudeSearchQuery} = useTrackAmplitudeGlobalSearch();
    const handleClick = (values: NewsletterSubscriptionPayloadType) => {
        saveNewsletterSearchData(values);
    };

    const [recentFilter] = recentFilters;

    if (!recentFilter) {
        return null;
    }

    return (
        <div className={css({mb: 3})}>
            <Text variant="mini_header" style={{display: "block", marginBottom: "1rem"}}>
                Twoje ostatnie wyszukiwania
            </Text>

            <RecentFilterButton
                url={buildSearchUrl(buildRecentSearchFormValues(recentFilter))}
                title={getRecentFilterFilterText(recentFilter)}
                text={`Wyszukiwanie z dnia: ${formatDate(new Date(recentFilter.timestamp).toISOString(), dateTimeFormat.shortDate)}`}
                className={className}
                isLast
                onClick={() => {
                    trackAmplitudeSearch({
                        searchQuery: buildAmplitudeSearchQuery(recentFilter.search, recentFilter.filters),
                        searchMethod: "recent_search_click"
                    });
                    handleClick(buildRecentSearchFormValues(recentFilter));
                }}
            />
        </div>
    );
};

interface IRecentFilterButtonProps {
    url: string;
    title: string;
    text: string;
    className?: string;
    isLast?: boolean;
    onClick?: () => void;
}

const RecentFilterButton = (props: IRecentFilterButtonProps) => {
    const {url, title, text, className, isLast, onClick} = props;

    return (
        <Button
            href={url}
            variant="none_secondary"
            fullWidth
            className={cx(recentFiltersButtonStyle, isLast && recentFiltersButtonLastStyle, className)}
            onClick={onClick}
        >
            <div className={recentFiltersTextWrapper}>
                <Text variant="body_copy_1" className={transformNone}>
                    {title}
                </Text>

                <Text variant="info_txt_1" color="var(--colors-gray-700)" className={transformNone}>
                    {text}
                </Text>
            </div>
        </Button>
    );
};

const recentFiltersButtonStyle = css({
    height: "auto",
    minHeight: "64px",
    textAlign: "left",
    textWrap: "wrap",
    justifyContent: "flex-start",
    borderBottom: "1px solid var(--colors-gray-200)",
    p: 1,
    gap: 1,
    borderRadius: 0,
    textDecoration: "none",
    color: "inherit",

    "& svg": {
        fill: "var(--colors-secondary)"
    },
    _hover: {
        backgroundColor: "var(--colors-gray-200)"
    },
    _focus: {
        backgroundColor: "var(--colors-gray-200)"
    }
});

const recentFiltersButtonLastStyle = css({
    borderBottom: "none"
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column"
});

const transformNone = css({
    textTransform: "none"
});
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

import {useSubscribeToNewsletter} from "../../newsletter/hooks/useSubscribeToNewsletter";
import {NewsletterSubscriptionPayloadType} from "../../newsletter/types/NewsletterSubscriptionPayloadType";
import {useRecentFilters} from "../hooks/use_recent_filters";
import {useTrackAmplitudeGlobalSearch} from "../tracking/use_track_amplitude_global_search";
import {buildRecentSearchFormValues, buildSearchUrl} from "../utils/build_recent_filters_search_values";
import {getRecentFilterFilterText} from "../utils/recent_filters_display_utils";

interface IProps {
    className?: string;
}

export const RecentFiltersSearch = (props: IProps) => {
    const {className} = props;

    const {recentFilters} = useRecentFilters();
    const {saveNewsletterSearchData} = useSubscribeToNewsletter();
    const {trackAmplitudeSearch, buildAmplitudeSearchQuery} = useTrackAmplitudeGlobalSearch();
    const handleClick = (values: NewsletterSubscriptionPayloadType) => {
        saveNewsletterSearchData(values);
    };

    const [recentFilter] = recentFilters;

    if (!recentFilter) {
        return null;
    }

    return (
        <div className={css({mb: 3})}>
            <Text variant="mini_header" style={{display: "block", marginBottom: "1rem"}}>
                Twoje ostatnie wyszukiwania
            </Text>

            <RecentFilterButton
                url={buildSearchUrl(buildRecentSearchFormValues(recentFilter))}
                title={getRecentFilterFilterText(recentFilter)}
                text={`Wyszukiwanie z dnia: ${formatDate(new Date(recentFilter.timestamp).toISOString(), dateTimeFormat.shortDate)}`}
                className={className}
                isLast
                onClick={() => {
                    trackAmplitudeSearch({
                        searchQuery: buildAmplitudeSearchQuery(recentFilter.search, recentFilter.filters),
                        searchMethod: "recent_search_click"
                    });
                    handleClick(buildRecentSearchFormValues(recentFilter));
                }}
            />
        </div>
    );
};

interface IRecentFilterButtonProps {
    url: string;
    title: string;
    text: string;
    className?: string;
    isLast?: boolean;
    onClick?: () => void;
}

const RecentFilterButton = (props: IRecentFilterButtonProps) => {
    const {url, title, text, className, isLast, onClick} = props;

    return (
        <Button
            href={url}
            variant="none_secondary"
            fullWidth
            className={cx(recentFiltersButtonStyle, isLast && recentFiltersButtonLastStyle, className)}
            onClick={onClick}
        >
            <div className={recentFiltersTextWrapper}>
                <Text variant="body_copy_1" className={transformNone}>
                    {title}
                </Text>

                <Text variant="info_txt_1" color="var(--colors-gray-700)" className={transformNone}>
                    {text}
                </Text>
            </div>
        </Button>
    );
};

const recentFiltersButtonStyle = css({
    height: "auto",
    minHeight: "64px",
    textAlign: "left",
    textWrap: "wrap",
    justifyContent: "flex-start",
    borderBottom: "1px solid var(--colors-gray-200)",
    p: 1,
    gap: 1,
    borderRadius: 0,
    textDecoration: "none",
    color: "inherit",

    "& svg": {
        fill: "var(--colors-secondary)"
    },
    _hover: {
        backgroundColor: "var(--colors-gray-200)"
    },
    _focus: {
        backgroundColor: "var(--colors-gray-200)"
    }
});

const recentFiltersButtonLastStyle = css({
    borderBottom: "none"
});

const recentFiltersTextWrapper = css({
    display: "flex",
    flexDirection: "column"
});

const transformNone = css({
    textTransform: "none"
});
